



























import {Drag} from "vue-drag-drop";
import {Vue, Component, Prop} from "vue-property-decorator";
import DynamicComponents from "./DynamicComponents.vue";
import {SComponents} from "./dto/SComponents";
import {SDynamicComponent} from "@/components/dto/SDynamicComponent";
import {ObjUtils} from "@/components/utils/ObjUtils";
import ComponentItemView from "@/components/ComponentItemView.vue";

@Component({
    components: {ComponentItemView, DynamicComponents,Drag}
})
export default class ComponentList extends Vue {
    @Prop() components!: SComponents[];
    @Prop() data!: any;

    openComponentSettings(item: any){
        this.handle_function_call('openComponentSettings', item);
    }
    handleDragstart(startData: any, event: any){
        this.handle_function_call('handleDragstart', [startData, event]);
    }
    handle_function_call(e: any, param: any) {
        this.$emit('callfunction', e, param);
    }

}
